var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"editor-toolbar":_vm.customToolbar},model:{value:(_vm.stageInfo.text_material),callback:function ($$v) {_vm.$set(_vm.stageInfo, "text_material", $$v)},expression:"stageInfo.text_material"}})}
var staticRenderFns = []

export { render, staticRenderFns }